import React from 'react'

const VideoVolumeIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.3927 6.54688L7.85075 11.7804H2.61719V19.6308H7.85075L14.3927 24.8644L14.3927 6.54688Z" stroke="white" strokeWidth="2.94388" strokeLinecap="round" stroke-linejoin="round" />
            <path d="M24.9507 6.45312C27.4035 8.90672 28.7814 12.2341 28.7814 15.7035C28.7814 19.1728 27.4035 22.5002 24.9507 24.9538M20.332 11.0717C21.5585 12.2985 22.2474 13.9622 22.2474 15.6969C22.2474 17.4316 21.5585 19.0953 20.332 20.3221" stroke="white" strokeWidth="2.94388" strokeLinecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default VideoVolumeIcon